import { Button, Container, ScrollView, Spinner, XStack, isWeb } from '@my/ui'
import { MainLayout, Meta, StructuredMeta } from 'app/components'

import { ArticleGrid, ArticleGridProps, EmptyArticles } from '../../components'
import { CategoryTabs } from '../../containers'
import { ArticleCategoryQueryOutput } from './queries'
import { RefreshControl } from 'react-native'
import config from 'app/config'

export interface ArticleCategoryScreenProps {
  loading: boolean
  articleCategory?: ArticleCategoryQueryOutput['ArticleCategories']['docs'][0]
  articles: ArticleGridProps['articles']
  fetchingMore: boolean
  hasMore: boolean
  onLoadMore: () => void

  refreshing: boolean
  onPullToRefresh: () => void
}

export const ArticleCategoryScreen = (props: ArticleCategoryScreenProps) => {
  return (
    <MainLayout>
      {props.articleCategory && (
        <>
          <Meta
            title={props.articleCategory.meta?.title || 'Articles'}
            description={props.articleCategory.meta?.description}
          />
          <StructuredMeta
            type="breadcrumb"
            breadcrumbs={[
              {
                name: 'Home',
                url: config.siteUrl,
              },
              {
                name: 'Life',
                url: `${config.siteUrl}/life`,
              },
              {
                name: props.articleCategory.name,
                url: `${config.siteUrl}/life/${props.articleCategory.slug}`,
              },
            ]}
          />
        </>
      )}
      <Container>
        {isWeb && <CategoryTabs />}
        <ScrollView
          refreshControl={
            <RefreshControl refreshing={props.refreshing} onRefresh={props.onPullToRefresh} />
          }
        >
          <Container spaceTop spaceBottom gutter gap="$4" size="base">
            {props.articles.length > 0 && <ArticleGrid articles={props.articles} />}
            {!props.loading && props.articles.length === 0 && <EmptyArticles />}
            {props.loading && (
              <XStack jc="center" ai="center" py="$3.5">
                <Spinner size="large" color="$black" />
              </XStack>
            )}
            {props.hasMore && (
              <XStack jc="center">
                <Button
                  theme="primary"
                  size="$4"
                  flexBasis={358}
                  loading={props.fetchingMore}
                  onPress={props.onLoadMore}
                >
                  Load more
                </Button>
              </XStack>
            )}
          </Container>
        </ScrollView>
      </Container>
    </MainLayout>
  )
}
